import { Text } from '@mnd-frontend/ui';
import { BlueLink } from '../styles';

const PanelFooter = ({ onExternalLinkClick }: { onExternalLinkClick: (title: string) => void }) => (
  <>
    <Text as="h3" variant="headlineSmall">
      Need more help?
    </Text>
    <BlueLink
      onClick={() => {
        onExternalLinkClick('Help center');
      }}
      target="_blank"
      href="https://help.mynewsdesk.com"
    >
      Visit our success center
    </BlueLink>
  </>
);

export default PanelFooter;
